import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { AudiogramClip, Clip, ImageClip, TextClip } from 'storyboard-renderer';

import { MediaLibraryComponent } from '../../../../../media-library/media-library.component';
import { DragService } from '../../../../shared/drag.service';
import { AudiogramEditorComponent } from '../../../audiogram-editor/audiogram-editor.component';
import { EditModal } from '../../../shared/edit-modal.service';
import { TextEditorComponent } from '../../../text-editor/text-editor.component';
import { TimelineService } from '../../timeline.service';

@Component({
  selector: 'app-clip',
  templateUrl: './clip.component.html',
  styleUrls: ['./clip.component.scss'],
})
export class ClipComponent implements OnInit {

  @Input() clip;
  @Input() layer;
  @Input() readonly;
  @Output() deleteClipEvent = new EventEmitter();
  @Output() duplicateClipEvent = new EventEmitter();
  @Output() onUpdatePreview = new EventEmitter();

  @ViewChild('p') popover: NgbPopover;

  userId = null;

  constructor(public element: ElementRef, private dragService: DragService, private timelineService: TimelineService,
              private modalService: EditModal, protected route: ActivatedRoute) {
    timelineService.zoomChangeEvent.subscribe(zoom => this.onZoomChange(zoom));

    this.route.params.subscribe(params => {
      this.userId = +params['user_id']; // (+) converts string 'id' to a number
    });

    modalService.modalOpened.subscribe((res: any) => {
      this.closeClipMenu();
    })
  }

  getStyle() {
    //console.log("running sdasdasd as d asd s d ");
  }

  ngOnInit() {
    this.timelineService.closeAllClipMenuEvent.subscribe(openedClip => {
      if (this.clip !== openedClip) {
        this.closeClipMenu();
      }
    });

    this.element.nativeElement.style.left = this.timelineService.convertTimeToPx(this.clip.starts_at.as_milliseconds) + 'px';
    this.element.nativeElement.style.width = this.timelineService.convertTimeToPx(this.clip.duration.as_milliseconds) + 'px';
  }

  onZoomChange(zoom) {
    this.element.nativeElement.style.left = this.timelineService.convertTimeToPx(this.clip.starts_at.as_milliseconds) + 'px';
    this.element.nativeElement.style.width = this.timelineService.convertTimeToPx(this.clip.duration.as_milliseconds) + 'px';
  }

  mouseDown(event, clip) {
    event.stopPropagation();

    if(this.readonly)
      return;

    if(this.popover.isOpen())
      return;

    const dragStartPosition = {x: DragService.getClientXFromEvent(event), y: DragService.getClientYFromEvent(event),
      element: {x: this.elPos().left, y: this.elPos().top}};

    this.dragService.setDragElement(this, dragStartPosition);
    this.dragService.setMouseDown((ev) => {
    });
    this.dragService.onDragMouseDown.next(event);
  }

  mouseUp(event, clip) {
    this.dragService.onDragMouseUp.next(event);
  }

  deleteClip(clip: Clip) {
    this.deleteClipEvent.next(clip);
  }

  duplicateClip(clip: Clip) {
    this.duplicateClipEvent.next(clip);
    this.closeClipMenu();
  }

  editClip(clip: Clip) {

    if(this.readonly)
      return;

    switch (clip.constructor.name) {

      case TextClip.name:
        this.openTextEditor(clip as TextClip);
        break;

      case ImageClip.name:
        this.openMediaLibrary(clip as ImageClip);
        break;

      case AudiogramClip.name:
        this.openAudiogramEditor(clip as AudiogramClip);
        break;
    }

    this.closeClipMenu();
  }

  setPreset(preset) {

    console.log(preset);

    const updatedPreset = Object.assign({}, preset);

    if(this.clip instanceof ImageClip) {
      this.fitToScreen();

      if (updatedPreset.id === 'zoom_to_left') {
        let scaleAmount = this.clip.dimensions.size.x * updatedPreset.config.scaleOutFactor - this.clip.dimensions.size.x;
        updatedPreset.config.scaleOutOffsetX = scaleAmount / 2;
      } else if (updatedPreset.id === 'zoom_to_right') {
        let scaleAmount = this.clip.dimensions.size.x * updatedPreset.config.scaleOutFactor - this.clip.dimensions.size.x;
        updatedPreset.config.scaleOutOffsetX = -(scaleAmount / 2);
      } else if (updatedPreset.id === 'pan_right') {
        let scaleAmount = this.clip.dimensions.size.x * updatedPreset.config.scaleOutFactor - this.clip.dimensions.size.x;
        updatedPreset.config.scaleOutOffsetX = -(scaleAmount / 2);
      } else if (updatedPreset.id === 'pan_left') {
        let scaleAmount = this.clip.dimensions.size.x * updatedPreset.config.scaleOutFactor - this.clip.dimensions.size.x;
        updatedPreset.config.scaleOutOffsetX = scaleAmount / 2;
      } else if (updatedPreset.id === 'tilt_up') {
        let scaleAmount = this.clip.dimensions.size.y * updatedPreset.config.scaleOutFactor - this.clip.dimensions.size.y;
        updatedPreset.config.scaleOutOffsetY = scaleAmount / 2;
      } else if (updatedPreset.id === 'tilt_down') {
        let scaleAmount = this.clip.dimensions.size.y * updatedPreset.config.scaleOutFactor - this.clip.dimensions.size.y;
        updatedPreset.config.scaleOutOffsetY = -(scaleAmount / 2);
      } else if (updatedPreset.id === 'zoom_out_from_left') {
        let scaleAmount = this.clip.dimensions.size.x * updatedPreset.config.scaleOutFactor - this.clip.dimensions.size.x;
        updatedPreset.config.scaleInOffsetX = scaleAmount / 2;
      } else if (updatedPreset.id === 'zoom_out_from_right') {
        let scaleAmount = this.clip.dimensions.size.x * updatedPreset.config.scaleOutFactor - this.clip.dimensions.size.x;
        updatedPreset.config.scaleInOffsetX = -(scaleAmount / 2);
      }
    }

    this.setScaleInOffsetX(updatedPreset.config.scaleInOffsetX);
    this.setScaleOutOffsetX(updatedPreset.config.scaleOutOffsetX);

    this.setScaleInFactor(updatedPreset.config.scaleInFactor);
    this.setScaleOutFactor(updatedPreset.config.scaleOutFactor);

    this.setScaleInOffsetY(updatedPreset.config.scaleInOffsetY);
    this.setScaleOutOffsetY(updatedPreset.config.scaleOutOffsetY);

  }

  setOpacity(value) {
    this.clip.effects.opacity = value;

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  setFadeIn(value) {
    this.clip.effects.fadeIn.setUntil(value);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  setFadeOut(value) {
    this.clip.effects.fadeOut.setFrom(value);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  setScaleInTime(value) {
    this.clip.effects.scaleIn.setUntil(value);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  setScaleOutTime(value) {
    this.clip.effects.scaleOut.setFrom(value);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  setScaleInFactor(value) {
    this.clip.effects.scaleIn.setFactor(value);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  setScaleOutFactor(value) {
    this.clip.effects.scaleOut.setFactor(value);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  setScaleInOffsetX(value) {
    this.clip.effects.scaleIn.setOffsetX(value);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  setScaleInOffsetY(value) {
    this.clip.effects.scaleIn.setOffsetY(value);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  setScaleOutOffsetX(value) {
    this.clip.effects.scaleOut.setOffsetX(value);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  setScaleOutOffsetY(value) {
    this.clip.effects.scaleOut.setOffsetY(value);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(true);
  }

  openAudiogramEditor(clip: AudiogramClip) {
    const modalRef = this.modalService.open(AudiogramEditorComponent, { size: 'lg' });
    modalRef.componentInstance.clip = Object.assign({}, clip);

    modalRef.result.then((result) => {
      this.clip.pattern = result.pattern;
      this.clip.color = result.color;
      this.clip.colorMiddle = result.colorMiddle;
      this.clip.colorEnd = result.colorEnd;
      this.clip.isMirror = result.isMirror;
      this.clip.isTiny = result.isTiny;
      this.clip.useFrequency = result.useFrequency;
      this.clip.isGradient = result.isGradient;

      this.layer.addClip(this.clip);

      setTimeout(() => {
        const i = this.layer.clips.indexOf(this.clip);
        this.layer.clips.splice(i, 1)
      });

      this.timelineService.storyboardChangeEvent.next(true);
    }, (reason) => {});
  }

  openTextEditor(clip: TextClip) {
    const modalRef = this.modalService.open(TextEditorComponent, {
      size: 'lg',
      backdrop: 'static'
    });
    modalRef.componentInstance.clip = clip;

    modalRef.result.then((result) => {
      this.clip.title = result.clip.text;

      if(result.applyForAll) {
        this.layer.clips.forEach((clip: TextClip) => clip.copyFormat(result.clip))
      }

      // Trigger Storyboard Object Change
      this.timelineService.storyboardChangeEvent.next(true);
    }, (reason) => {});
  }

  openMediaLibrary(clip: ImageClip) {
    const modalRef = this.modalService.open(MediaLibraryComponent, { size: 'lg' });
    modalRef.componentInstance.userId = this.userId;

    modalRef.result.then((result) => {
      this.clip.title = result.title;
      this.clip.attachment = result;

      // Trigger Storyboard Object Change
      this.timelineService.storyboardChangeEvent.next(true);
    }, (reason) => {});
  }

  elPos() {
    return {
      top: parseInt(this.element.nativeElement.style.top, 10),
      left: parseInt(this.element.nativeElement.style.left, 10)
    }
  }

  closeClipMenu() {
    this.popover.close();
  }

  isActive() {
    if(!this.clip.transcription) {
      return false;
    }

    const currentTime = this.timelineService.getPlayerControl().getCurrentTime();
    return this.clip.starts_at.before(currentTime) && this.clip.endsAtAbsolute().after(currentTime);
  }

  getTooltip() {
    return this.clip.transcription && this.clip.starts_at.asMinutesSecondsString() + " " + this.clip.text;
  }

  onRightClick(event: MouseEvent) {
    // preventDefault avoids to show the visualization of the right-click menu of the browser
    event.preventDefault();

    this.popover.open();
  }

  fitToScreen() {
    let arParts = this.timelineService.getStoryboard().aspect_ratio.split(':');
    let ar = +arParts[0] / +arParts[1];

    let stageHeight = 720;
    let stageWidth = 720 * ar;
    let imageRatio = this.clip.dimensions.size.x / this.clip.dimensions.size.y;

    this.clip.forceRecalculate = true;

    this.clip.dimensions.size.x = stageWidth / 2;
    this.clip.dimensions.size.y = this.clip.dimensions.size.x / imageRatio;

    if (this.clip.dimensions.size.y < stageHeight / 2){
      this.clip.dimensions.size.y = stageHeight / 2;
      this.clip.dimensions.size.x = this.clip.dimensions.size.y * imageRatio;
    }

    this.clip.dimensions.position.x = stageWidth / 4;
    this.clip.dimensions.position.y = stageHeight / 4;

    this.timelineService.storyboardChangeEvent.next(true);
  }

  scaleToScreen() {
    let arParts = this.timelineService.getStoryboard().aspect_ratio.split(':');
    let ar = +arParts[0] / +arParts[1];

    let stageHeight = 720;
    let stageWidth = 720 * ar;
    let imageRatio = this.clip.dimensions.size.x / this.clip.dimensions.size.y;

    this.clip.forceRecalculate = true;

    this.clip.dimensions.size.x = stageWidth / 2;
    this.clip.dimensions.size.y = this.clip.dimensions.size.x / imageRatio;

    if (this.clip.dimensions.size.y > stageHeight / 2){
      this.clip.dimensions.size.y = stageHeight / 2;
      this.clip.dimensions.size.x = this.clip.dimensions.size.y * imageRatio;
    }

    this.clip.dimensions.position.x = stageWidth / 4;
    this.clip.dimensions.position.y = stageHeight / 4;

    this.timelineService.storyboardChangeEvent.next(true);
  }

  rotate(number: number) {
    this.clip.forceRecalculate = true;
    this.clip.effects.rotation.radians += number * (Math.PI / 180);
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/video-layer/clip/clip.component.ts